export const STRIPE_PRIMARY = '#635bff'
export const STRIPE_PRIMARY_HOVER = '#5851ec'
export const STRIPE_PRIMARY_DARK = '#4c46c8'
export const STRIPE_TEXT_PRIMARY = '#32325d'
export const STRIPE_TEXT_SECONDARY = '#6b7c93'
export const LINQ_BLUE_PRODUCT_IDS = [
  'prod_RQjmrtiHgXI5PS',
  'prod_RxcxDOznMdQK4P',
  'prod_SWZNukOZ3DbC6t',
  'prod_SBqc16CdZ4fc9Z',
  'prod_UDIqyvLTlQVH54',
]
export const LINQ_BLUE_INFRASTRUCTURE_PRODUCT_ID = [
  'prod_TI8X1aY7VApKAs',
  'prod_V0ouQMnfLdZU3s',
]

export const getCardBrandIcon = (brand: string) => {
  const brandLower = brand.toLowerCase()
  switch (brandLower) {
    case 'visa':
      return (
        <img src="/banking-cards/visa.jpeg" alt="Visa" width="32" height="20" />
      )
    case 'mastercard':
      return (
        <img
          src="/banking-cards/master.png"
          alt="Mastercard"
          width="32"
          height="20"
        />
      )
    case 'amex':
      return (
        <img
          src="/banking-cards/amex.png"
          alt="American Express"
          width="32"
          height="20"
        />
      )
    case 'discover':
      return (
        <img
          src="/banking-cards/discover.png"
          alt="Discover"
          width="32"
          height="20"
        />
      )
    default:
      return (
        <svg width="32" height="20" viewBox="0 0 32 20" fill="none">
          <rect width="32" height="20" rx="4" fill="#94A3B8" />
          <rect x="8" y="6" width="16" height="8" rx="2" fill="white" />
        </svg>
      )
  }
}
